import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class AdminVendorUserRemoveEffects {
	create = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.vendorUsers.removeUser),
			switchMap((action) =>
				this.mpAdminService
					.removeVendorUser(action.params.vendorId, action.params.userId)
					.pipe(
						map(() => MpAdminActions.vendorUsers.removeUserSuccess()),
						catchError((error) =>
							of(MpAdminActions.vendorUsers.removeUserFail(new FailState(error)))
						)
					)
			)
		)
	);

	constructor(
		private actions: Actions,
		private mpAdminService: MpAdminService
	) {}
}
